import * as React from "react";
const SvgChartPie24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M11 .1h-.9v11.8h11.8V11C21.9 4.98 17.02.1 11 .1Zm.9 10V1.944a9.103 9.103 0 0 1 8.156 8.156H11.9ZM0 12.5c0-4.736 3.466-8.663 8-9.382V5.15A7.5 7.5 0 1 0 16.85 14h2.032c-.719 4.534-4.646 8-9.382 8A9.5 9.5 0 0 1 0 12.5Z",
      clipRule: "evenodd"
    })
  );
export default SvgChartPie24Px;
